import React, { useState } from 'react';
import Icon from '../common/Icon';

const AddFilterField = ({
  fieldsets,
  ffIds,
  handleAddFilterField,
  filtersFull,
}) => {
  const [selectedField, setSelectedField] = useState(null);

  return (
    <>
      <header>
        <h3>Add Default Filter</h3>
      </header>

      <div className='creation-form'>
        <div className='row'>
          <label>
            Users without custom filter fields will see these by default.
          </label>
          <div className='select-input'>
            <select
              name='fieldset'
              id='fieldset'
              onChange={(e) => setSelectedField(e.target.value)}
            >
              <option value=''>Select Field</option>
              {fieldsets.length > 0 &&
                fieldsets.map((fs) => {
                  return (
                    <optgroup key={fs.id} label={fs.name}>
                      {fs.fields.map((field) => {
                        return (
                          <option
                            key={field.id}
                            value={field.id}
                            disabled={ffIds.includes(field.id)}
                          >
                            {field.name}
                          </option>
                        );
                      })}
                    </optgroup>
                  );
                })}
            </select>
          </div>
        </div>

        {filtersFull && (
          <span className='errors'>
            Form already has maximum number of filters.
          </span>
        )}
        <div className='controls'>
          <button
            className='single'
            disabled={filtersFull}
            onClick={() => handleAddFilterField(selectedField)}
          >
            Add
            <Icon icon='plus' />
          </button>
        </div>
      </div>
    </>
  );
};

export default AddFilterField;
